<!--
     <FieldDate>
-->

<template>
  <span v-if="representation">
    <v-icon small class="fielddate-calendar-icon">
      mdi-calendar
    </v-icon>
    <span style="padding-left: .2em" :class="class_limit_time">{{ representation }}</span>
  </span>
</template>

<style>
.fielddate-calendar-icon:after{
  height: unset !important;
}
</style>

<script>
 export default {
   name: 'FieldDate',

   props: ['field'],

   computed: {
     representation() {
       return '' + this.field;
     },
     class_limit_time() {
      return this.field.limit_time()
     },
   },
 };
</script>
